import { ArrowTopRightOnSquareIcon } from "@heroicons/react/24/outline";
import { getReadablePageName } from "@via/components/cortex-drawer/helpers/utils";

interface ConversationPagePromptProps {
  visible: boolean;
  pageUrl: string;
  onNavigate: () => void;
  onDismiss: () => void;
}

export function ConversationPagePrompt({
  visible,
  pageUrl,
  onNavigate,
  onDismiss,
}: ConversationPagePromptProps) {
  if (!visible) return null;

  const pageName = getReadablePageName(pageUrl);

  return (
    <div className="mb-3">
      <div className="group relative w-full rounded-2xl border border-indigo-200/60 bg-gradient-to-br from-indigo-50 to-purple-50 p-4 text-gray-800 shadow-md">
        <div className="flex items-start gap-2">
          <ArrowTopRightOnSquareIcon className="h-5 w-5 flex-shrink-0 text-indigo-500" />
          <div className="flex-1 space-y-2">
            <p className="text-sm leading-relaxed">
              This conversation was started on <strong>{pageName}</strong>.
              Navigate there to continue in the original context?
            </p>
            <div className="flex items-center justify-between gap-2">
              <button
                type="button"
                onClick={onDismiss}
                className="text-xs font-medium text-gray-500 hover:text-gray-700 underline transition-colors">
                Stay here
              </button>
              <button
                type="button"
                onClick={onNavigate}
                className="inline-flex items-center gap-1.5 rounded-full bg-indigo-600 px-3 py-1.5 text-xs font-semibold text-white shadow-sm transition-colors duration-200 hover:bg-indigo-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
                <ArrowTopRightOnSquareIcon className="h-4 w-4" />
                <span>Go to {pageName}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
